import {
  CascadiaJsonFormContext,
  CascadiaLayoutProps,
  withCascadiaLayoutProps,
} from "@certn/forms";
import { RenderError } from "@certn/forms/src/components/helpers/RenderError";
import { BaseLayout } from "@certn/forms/src/layouts/BaseLayout";
import { BaseLayoutContent } from "@certn/forms/src/layouts/BaseLayoutContent";
import { hasLabel } from "@certn/forms/src/utils";
import { css } from "@emotion/css";
import { isBooleanControl, rankWith } from "@jsonforms/core";
import { useContext } from "react";

import { AfpConsentControlRenderer } from "../controls/consent-control/AfpConsentControl";
import { AfpConsentLayoutContext } from "./AfpConsentLayoutContext";

function AfpConsentLayout(props: CascadiaLayoutProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    // We don't render anything in the summary for consents.
    return null;
  }

  const { uischema } = props;
  const options = uischema.options || {};

  if (!hasLabel(uischema)) {
    return <RenderError>Invalid Category</RenderError>;
  }

  return (
    <BaseLayout {...props} className={styles.layout}>
      <AfpConsentLayoutContext.Provider
        value={{ label: uischema.label, subLabel: options.subLabel }}
      >
        <BaseLayoutContent
          renderers={[
            {
              tester: rankWith(1, isBooleanControl),
              renderer: AfpConsentControlRenderer,
            },
          ]}
        />
      </AfpConsentLayoutContext.Provider>
    </BaseLayout>
  );
}

const styles = {
  layout: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
  }),
};

AfpConsentLayout.displayName = "AfpConsentSection";

export const AfpConsentLayoutRenderer =
  withCascadiaLayoutProps(AfpConsentLayout);
